import styled from '@emotion/styled';
import { Form } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

const FBForm = ({ children, ...props }) => (
  <Form layout="vertical" {...props}>
    {children}
  </Form>
);

/**
 * `margin-bottom` and the label's `line-height` are deliberately here rather than in the theme:
 * `Form.itemMarginBottom` would also reach the two call sites that import Form straight from antd,
 * and the BO Figma file has no Form control to authorise moving them off antd's defaults.
 * The label's `padding-bottom` used to be restated here at 8px — that is exactly antd's
 * `verticalLabelPadding` default, and every call site is vertical, so it was doing nothing.
 */
const FBFormItem = styled(Form.Item)`
  margin-bottom: 8px;
  .ant-form-item-label {
    line-height: 16px;

    > label.ant-form-item-required::before {
      content: "${({ requiredMark }) => requiredMark}" !important;
    }

    .ant-form-item-tooltip {
      margin-inline-start: 8px !important;
      cursor: default !important;
    }
  }

  &.noContent {
    margin-bottom: 0;

    .ant-form-item-control-input {
      min-height: 0;
    }
  }
`;

/** @type {React.FC<import('antd/lib/form').FormItemProps & { noContent?: Boolean }>} */
const FormItem = ({ className, children, noContent, ...rest }) => {
  const intl = useIntl();
  const requiredMark = intl.formatMessage({ id: 'requiredMark', defaultMessage: '*' });

  return (
    <FBFormItem className={classNames(className, { noContent })} colon={false} requiredMark={requiredMark} layout="vertical" {...rest}>
      {children}
    </FBFormItem>
  );
};

FBForm.Item = FormItem;

export default FBForm;
